<template>
  <div class="block">
    <div class="w-full">
      <LeftCard />
    </div>
    <div class="w-full mt-8">
      <!-- <RightTable /> -->
      <WireframeTab />
    </div>
  </div>
</template>
<script>
import LeftCard from "./LeftCard";
import WireframeTab from "../../components/WireframeTab.vue";
export default {
  components: {
    LeftCard,
    WireframeTab,
  },
};
</script>
